import React from "react";
import IPagination from "./Pagination";
import { LeftArrowsIcon, RightArrowsIcon } from "../../../assets/Icons";
import clsx from "clsx";

const Pagination: React.FunctionComponent<IPagination.IProps> = (props) => {
  const {
    pageSize,
    currentPage,
    siblingButtonClassname,
    siblingIconClassname,
    totalItems,
    setPagination,
    pagination,
  } = props;
  const totalPages = pagination?.totalPages || 1;

  const handlePrevClick = () => {
    if (currentPage !== undefined && currentPage > 0) {
      if (setPagination) {
        setPagination((prev) => ({
          ...prev,
          page: prev.page - 1,
        }));
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    }
  };

  const handleNextClick = () => {
    if (currentPage !== undefined && currentPage < totalPages - 1) {
      if (setPagination) {
        setPagination((prev) => ({
          ...prev,
          page: prev.page + 1,
        }));
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    }
  };

  const handleLastPageClick = () => {
    if (setPagination) {
      setPagination((prev) => ({
        ...prev,
        page: totalPages - 1,
      }));
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };


  const handlePageSizeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    if (setPagination) {
      setPagination((prev) => ({
        ...prev,
        size: parseInt(e.target.value),
      }));
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const firstPage = () => {
    const startRow = (currentPage || 0) * (pageSize || 10) + 1;
    const endRow = Math.min(startRow + (pageSize || 10) - 1, totalItems || 0);

    return <span className={clsx("mr-1 hidden md:block font-medium text-[#111827]")}>{`${startRow}-${endRow}`}</span>;
  };

  return (
    <div className={clsx("flex w-full items-center justify-between text-sm py-2 px-3 bg-white border border-[#E7EBF3] rounded-xl shadow-sm")}>
      <div className="flex w-full justify-start items-center text-[#6B7280]">
        {firstPage()}
        <span>of <span className="font-semibold text-[#111827]">{totalItems || 0}</span></span>
      </div>
      <div className="w-full flex justify-end items-center gap-2">
        <p className="flex px-1 justify-start items-center gap-2 text-[#6B7280]">
          <span className="whitespace-nowrap">Rows per page:</span>
          <select
            defaultValue={10}
            value={pagination?.size}
            onChange={handlePageSizeChange}
            className="px-2 py-1 rounded-lg border border-[#D9E1EF] bg-[#F8FAFF] text-[#111827] outline-none focus:border-primary"
          >
            {[10, 20, 30, 40, 50].map((list, index) => (
              <option value={list} key={index}>
                {list}
              </option>
            ))}
          </select>
        </p>
        <span className="px-2 py-1 rounded-md bg-[#F4F7FD] border border-[#E7EBF3] text-[#374151]">
          Page {(currentPage || 0) + 1} / {Math.max(totalPages, 1)}
        </span>
        <button
          className={clsx(
            "relative inline-flex p-2 overflow-hidden border border-[#D9E1EF] bg-white rounded-lg cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed hover:bg-[#F8FAFF] transition-colors mx-1",
            siblingButtonClassname,
          )}
          onClick={handlePrevClick}
          type={"button"}
          disabled={(currentPage || 0) === 0}
        >
          <i
            className={clsx(
              "flex flex-shrink-0 w-4 h-4 text-[#2563EB] fill-current",
              siblingIconClassname,
            )}
          >
            <LeftArrowsIcon />
          </i>
        </button>

        <button
          className={clsx(
            "relative inline-flex p-2 overflow-hidden border border-[#D9E1EF] bg-white rounded-lg cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed hover:bg-[#F8FAFF] transition-colors",
            siblingButtonClassname,
          )}
          onClick={handleNextClick}
          type={"button"}
          aria-label={"Next"}
          disabled={(currentPage || 0) >= totalPages - 1}
        >
          <i
            className={clsx(
              "flex flex-shrink-0 w-4 h-4 text-[#2563EB] fill-current",
              siblingIconClassname,
            )}
          >
            <RightArrowsIcon />
          </i>
        </button>

        <button
          className={clsx(
            "relative inline-flex p-2 overflow-hidden border border-[#D9E1EF] bg-white rounded-lg cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed hover:bg-[#F8FAFF] transition-colors",
            siblingButtonClassname
          )}
          onClick={handleLastPageClick}
          type={"button"}
          aria-label={"Last Page"}
          disabled={(currentPage || 0) >= totalPages - 1}
        >
          <i
            className={clsx(
              "flex flex-shrink-0 w-4 h-4 text-[#2563EB] fill-current",
              siblingIconClassname
            )}
          >
            <RightArrowsIcon />
            <RightArrowsIcon style={{ marginLeft: "-4px" }} />
          </i>
        </button>
      </div>
    </div>
  );
};

export default Pagination;
